import styled, { css } from 'styled-components';

export const FormWrapper = styled.div`
  overflow-y: hidden;
  width: 100%;
  position: relative;

  transition: all 0.4s ease-in-out;

  height: 600px;

  @media (max-width: 1200px) {
    display: block;
    height: 100%;
    flex: 1;
    padding: 0;
  }
  .fade-enter {
    opacity: 0;
    transform: translateY(50%);
  }

  .fade-enter-active {
    opacity: 1;
    transform: translateY(0%);
  }
  .fade-exit {
    opacity: 1;
    transform: translateY(0%);
  }
  .fade-exit-active {
    opacity: 0;
    transform: translateY(-50%);
  }
  .fade-enter-active,
  .fade-exit-active {
    transition: opacity 200ms, transform 200ms;
  }

  .fade-out-enter {
    opacity: 0;
    transform: translateY(-50%);
  }
  .fade-out-enter-active {
    opacity: 1;
    transform: translateY(0%);
  }
  .fade-out-exit {
    opacity: 1;
    transform: translateY(0);
  }
  .fade-out-exit-active {
    opacity: 0;
    transform: translateY(50%);
  }
  .fade-out-enter-active,
  .fade-out-exit-active {
    transition: opacity 200ms, transform 200ms;
  }
`;
